module.exports = __webpack_public_path__ + "assets/static/png/games-grey.6b68a5b1391bc2c0e8ee2b70c3946817.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/games-grey.png
 ** module id = 505
 ** module chunks = 1
 **/